const styles = () => ({
  content: {
    flex: 'auto',
    position: 'relative',
    overflowX: 'auto',
  },
});

export default styles;
